import React from "react";
import "./Main.css";

import FondoMobile from "../assets/Cargando/Cargando-vertical.png";
import FondoDesktop from "../assets/Cargando/Cargando-horizontal.png";
 // eslint-disable-next-line
import compras from "../assets/Cargando/Bot_gacetilla.png";
 // eslint-disable-next-line
import logosProducen from "../assets/logos_producen.png";
class Cargando extends React.Component {
  render() {
    const min = window.innerWidth >= 790;
    const backImg = min ? FondoDesktop : FondoMobile;

    return (
      <div
        style={{
          width: "100vw",
          height: "100dvh",
          backgroundImage: `url(${backImg})`,
          backgroundColor: "#000",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Botón Compras */}
         <div
          style={{
            position: "absolute",
            bottom: min ? "2%" : "20%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <a
            href="https://drive.google.com/file/d/1xKF1nwRBrHRwdcxWESr9DtKoqqIeoohE/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={compras}
              alt="Comprar Entradas"
              style={{
                width: min ? "620px" : "370px",
                display: "block",
              }}
            />
          </a>
        </div>
        {/* Logos producen abajo */}
        {/* <div
          style={{
            position: "absolute",
            bottom: min ? "2%" : "3%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <img
            src={logosProducen}
            alt="producen"
            style={{
              height: min ? "55px" : "38px",
              width: "auto",
              maxWidth: min ? "70%" : "85%",
              objectFit: "contain",
            }}
          />
        </div> */}
      </div>
    );
  }
}

export default Cargando;
